import { useEffect, useState } from 'react'

export function useEvalImagePreview(
  enabled: boolean,
  fullUrl: string | undefined,
  thumbnailUrl: string | undefined
) {
  const [loadedUrl, setLoadedUrl] = useState<string>()
  useEffect(() => {
    if (!enabled || !fullUrl) return
    const image = new Image()
    image.onload = () => setLoadedUrl(fullUrl)
    image.src = fullUrl
    return () => {
      image.onload = null
      image.src = ''
    }
  }, [enabled, fullUrl])
  const isFullImageLoaded = !!fullUrl && loadedUrl === fullUrl
  return enabled && !isFullImageLoaded ? (thumbnailUrl ?? fullUrl) : fullUrl
}
